import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormSelect, SectionHeader } from '../../form';

const CreditCardProcessing: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();
  const isEuropeOrOther = formik.values.reg === 'eu' || formik.values.reg === 'other';

  return (
    <SectionHeader
      title={t('prechecks.creditCardProcessing')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      }
      iconBgColor="bg-emerald-100"
      iconTextColor="text-emerald-600"
      titleColor="text-emerald-600"
    >
      <FormSelect
        id="ccpFulfill"
        name="ccpFulfill"
        label={t('prechecks.isFulfillmentCenterUsed')}
        value={formik.values.ccpFulfill}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        options={[
          { value: 'no', label: t('common.no') },
          { value: 'yes', label: t('common.yes') },
        ]}
        error={formik.errors.ccpFulfill}
        touched={formik.touched.ccpFulfill}
        description={t('prechecks.fulfillmentCenterDescription')}
      />

      <FormSelect
        id="ccpCallCtr"
        name="ccpCallCtr"
        label={t('prechecks.isCallCenterUsed')}
        value={formik.values.ccpCallCtr}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        options={[
          { value: 'no', label: t('common.no') },
          { value: 'yes', label: t('common.yes') },
        ]}
        error={formik.errors.ccpCallCtr}
        touched={formik.touched.ccpCallCtr}
      />

      <FormSelect
        id="ccpLic"
        name="ccpLic"
        label={t('prechecks.doYouHoldBusinessLicense')}
        value={formik.values.ccpLic}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        options={[
          { value: 'no', label: t('common.no') },
          { value: 'yes', label: t('common.yes') },
        ]}
        error={formik.errors.ccpLic}
        touched={formik.touched.ccpLic}
      />

      <FormField
        id="ccpLicJur"
        name="ccpLicJur"
        label={t('prechecks.licenseJurisdiction')}
        type="text"
        value={formik.values.ccpLicJur}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />

      <FormField
        id="ccpBankAcq"
        name="ccpBankAcq"
        label={t('prechecks.completeListBankAcquirers')}
        type="text"
        value={formik.values.ccpBankAcq}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.ccpBankAcq}
        touched={formik.touched.ccpBankAcq}
        description={t('prechecks.bankAcquirersDescription')}
      />

      <FormField
        id="ccpCurrMCC"
        name="ccpCurrMCC"
        label={t('prechecks.currentMCCCodes')}
        type="text"
        value={formik.values.ccpCurrMCC}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        description={t('prechecks.mccCodesDescription')}
      />

      <FormField
        id="ccpAvgTxVal"
        name="ccpAvgTxVal"
        label={t('prechecks.averageTransactionValue')}
        type="text"
        value={formik.values.ccpAvgTxVal}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.ccpAvgTxVal}
        touched={formik.touched.ccpAvgTxVal}
      />

      <FormField
        id="ccpCurrMonthVol"
        name="ccpCurrMonthVol"
        label={t('prechecks.currentMonthlyProcessingVolume')}
        type="text"
        value={formik.values.ccpCurrMonthVol}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.ccpCurrMonthVol}
        touched={formik.touched.ccpCurrMonthVol}
      />

      <FormField
        id="ccpExpMonthVol"
        name="ccpExpMonthVol"
        label={t('prechecks.expectedMonthlyProcessingVolumeAccount')}
        type="text"
        value={formik.values.ccpExpMonthVol}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.ccpExpMonthVol}
        touched={formik.touched.ccpExpMonthVol}
      />

      <FormField
        id="ccpDescLine1"
        name="ccpDescLine1"
        label={t('prechecks.billingDescriptorLine1DBA')}
        type="text"
        value={formik.values.ccpDescLine1}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        description={t('prechecks.billingDescriptorLine1Description')}
      />

      <FormField
        id="ccpDescLine2"
        name="ccpDescLine2"
        label={t('prechecks.billingDescriptorLine2')}
        type="text"
        value={formik.values.ccpDescLine2}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        description={t('prechecks.billingDescriptorLine2Description')}
      />

      <FormField
        id="ccpPrefGateway"
        name="ccpPrefGateway"
        label={t('prechecks.preferredCurrentGateway')}
        type="text"
        value={formik.values.ccpPrefGateway}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        description={t('prechecks.preferredGatewayDescription')}
      />

      {isEuropeOrOther && (
        <>
          <FormField
            id="ccpProcCurr"
            name="ccpProcCurr"
            label={t('prechecks.processingCurrenciesNeeded')}
            type="text"
            value={formik.values.ccpProcCurr}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <FormField
            id="ccpSettleCurr"
            name="ccpSettleCurr"
            label={t('prechecks.settlementCurrenciesNeeded')}
            type="text"
            value={formik.values.ccpSettleCurr}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

          <FormField
            id="ccpTargetMarkets"
            name="ccpTargetMarkets"
            label={t('prechecks.targetMarkets')}
            type="text"
            value={formik.values.ccpTargetMarkets}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </>
      )}
    </SectionHeader>
  );
};

export default CreditCardProcessing;
